// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file webrtc_signal.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { TraceContext } from "./common_pb.js";

/**
 * @generated from message cuda_learning.StartSessionRequest
 */
export class StartSessionRequest extends Message<StartSessionRequest> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: string sdp_offer = 3 [json_name = "sdp_offer"];
   */
  sdpOffer = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<StartSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StartSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sdp_offer", jsonName: "sdp_offer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartSessionRequest {
    return new StartSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartSessionRequest {
    return new StartSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartSessionRequest {
    return new StartSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartSessionRequest | PlainMessage<StartSessionRequest> | undefined, b: StartSessionRequest | PlainMessage<StartSessionRequest> | undefined): boolean {
    return proto3.util.equals(StartSessionRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.StartSessionResponse
 */
export class StartSessionResponse extends Message<StartSessionResponse> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: string sdp_answer = 3 [json_name = "sdp_answer"];
   */
  sdpAnswer = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<StartSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.StartSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sdp_answer", jsonName: "sdp_answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartSessionResponse {
    return new StartSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartSessionResponse {
    return new StartSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartSessionResponse {
    return new StartSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartSessionResponse | PlainMessage<StartSessionResponse> | undefined, b: StartSessionResponse | PlainMessage<StartSessionResponse> | undefined): boolean {
    return proto3.util.equals(StartSessionResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.IceCandidate
 */
export class IceCandidate extends Message<IceCandidate> {
  /**
   * @generated from field: string candidate = 1;
   */
  candidate = "";

  /**
   * @generated from field: string sdp_mid = 3 [json_name = "sdp_mid"];
   */
  sdpMid = "";

  /**
   * @generated from field: int32 sdp_mline_index = 5 [json_name = "sdp_mline_index"];
   */
  sdpMlineIndex = 0;

  constructor(data?: PartialMessage<IceCandidate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.IceCandidate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "candidate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sdp_mid", jsonName: "sdp_mid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sdp_mline_index", jsonName: "sdp_mline_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IceCandidate {
    return new IceCandidate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IceCandidate {
    return new IceCandidate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IceCandidate {
    return new IceCandidate().fromJsonString(jsonString, options);
  }

  static equals(a: IceCandidate | PlainMessage<IceCandidate> | undefined, b: IceCandidate | PlainMessage<IceCandidate> | undefined): boolean {
    return proto3.util.equals(IceCandidate, a, b);
  }
}

/**
 * @generated from message cuda_learning.SendIceCandidateRequest
 */
export class SendIceCandidateRequest extends Message<SendIceCandidateRequest> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: cuda_learning.IceCandidate candidate = 3;
   */
  candidate?: IceCandidate;

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<SendIceCandidateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.SendIceCandidateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "candidate", kind: "message", T: IceCandidate },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendIceCandidateRequest {
    return new SendIceCandidateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendIceCandidateRequest {
    return new SendIceCandidateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendIceCandidateRequest {
    return new SendIceCandidateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendIceCandidateRequest | PlainMessage<SendIceCandidateRequest> | undefined, b: SendIceCandidateRequest | PlainMessage<SendIceCandidateRequest> | undefined): boolean {
    return proto3.util.equals(SendIceCandidateRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.SendIceCandidateResponse
 */
export class SendIceCandidateResponse extends Message<SendIceCandidateResponse> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: bool accepted = 3;
   */
  accepted = false;

  /**
   * @generated from field: string message = 5;
   */
  message = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 7 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<SendIceCandidateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.SendIceCandidateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "accepted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendIceCandidateResponse {
    return new SendIceCandidateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendIceCandidateResponse {
    return new SendIceCandidateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendIceCandidateResponse {
    return new SendIceCandidateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendIceCandidateResponse | PlainMessage<SendIceCandidateResponse> | undefined, b: SendIceCandidateResponse | PlainMessage<SendIceCandidateResponse> | undefined): boolean {
    return proto3.util.equals(SendIceCandidateResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.CloseSessionRequest
 */
export class CloseSessionRequest extends Message<CloseSessionRequest> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 3 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<CloseSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.CloseSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloseSessionRequest {
    return new CloseSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloseSessionRequest {
    return new CloseSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloseSessionRequest {
    return new CloseSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CloseSessionRequest | PlainMessage<CloseSessionRequest> | undefined, b: CloseSessionRequest | PlainMessage<CloseSessionRequest> | undefined): boolean {
    return proto3.util.equals(CloseSessionRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.CloseSessionResponse
 */
export class CloseSessionResponse extends Message<CloseSessionResponse> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: bool closed = 3;
   */
  closed = false;

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 5 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<CloseSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.CloseSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "closed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloseSessionResponse {
    return new CloseSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloseSessionResponse {
    return new CloseSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloseSessionResponse {
    return new CloseSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CloseSessionResponse | PlainMessage<CloseSessionResponse> | undefined, b: CloseSessionResponse | PlainMessage<CloseSessionResponse> | undefined): boolean {
    return proto3.util.equals(CloseSessionResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.PollEventsRequest
 */
export class PollEventsRequest extends Message<PollEventsRequest> {
  /**
   * @generated from field: string session_id = 1 [json_name = "session_id"];
   */
  sessionId = "";

  /**
   * @generated from field: int64 cursor = 3;
   */
  cursor = protoInt64.zero;

  /**
   * @generated from field: int64 timeout_ms = 5 [json_name = "timeout_ms"];
   */
  timeoutMs = protoInt64.zero;

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 7 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<PollEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.PollEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session_id", jsonName: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cursor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "timeout_ms", jsonName: "timeout_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PollEventsRequest {
    return new PollEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PollEventsRequest {
    return new PollEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PollEventsRequest {
    return new PollEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PollEventsRequest | PlainMessage<PollEventsRequest> | undefined, b: PollEventsRequest | PlainMessage<PollEventsRequest> | undefined): boolean {
    return proto3.util.equals(PollEventsRequest, a, b);
  }
}

/**
 * @generated from message cuda_learning.PollEventsResponse
 */
export class PollEventsResponse extends Message<PollEventsResponse> {
  /**
   * @generated from field: repeated cuda_learning.SignalingMessage events = 1;
   */
  events: SignalingMessage[] = [];

  /**
   * @generated from field: int64 next_cursor = 3 [json_name = "next_cursor"];
   */
  nextCursor = protoInt64.zero;

  /**
   * @generated from field: int64 poll_timeout_ms = 5 [json_name = "poll_timeout_ms"];
   */
  pollTimeoutMs = protoInt64.zero;

  /**
   * @generated from field: cuda_learning.TraceContext trace_context = 7 [json_name = "trace_context"];
   */
  traceContext?: TraceContext;

  constructor(data?: PartialMessage<PollEventsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.PollEventsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: SignalingMessage, repeated: true },
    { no: 3, name: "next_cursor", jsonName: "next_cursor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "poll_timeout_ms", jsonName: "poll_timeout_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "trace_context", jsonName: "trace_context", kind: "message", T: TraceContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PollEventsResponse {
    return new PollEventsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PollEventsResponse {
    return new PollEventsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PollEventsResponse {
    return new PollEventsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PollEventsResponse | PlainMessage<PollEventsResponse> | undefined, b: PollEventsResponse | PlainMessage<PollEventsResponse> | undefined): boolean {
    return proto3.util.equals(PollEventsResponse, a, b);
  }
}

/**
 * @generated from message cuda_learning.KeepAlive
 */
export class KeepAlive extends Message<KeepAlive> {
  /**
   * @generated from field: int64 timestamp = 1;
   */
  timestamp = protoInt64.zero;

  constructor(data?: PartialMessage<KeepAlive>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.KeepAlive";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KeepAlive {
    return new KeepAlive().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KeepAlive {
    return new KeepAlive().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KeepAlive {
    return new KeepAlive().fromJsonString(jsonString, options);
  }

  static equals(a: KeepAlive | PlainMessage<KeepAlive> | undefined, b: KeepAlive | PlainMessage<KeepAlive> | undefined): boolean {
    return proto3.util.equals(KeepAlive, a, b);
  }
}

/**
 * @generated from message cuda_learning.SignalingMessage
 */
export class SignalingMessage extends Message<SignalingMessage> {
  /**
   * @generated from oneof cuda_learning.SignalingMessage.message
   */
  message: {
    /**
     * @generated from field: cuda_learning.StartSessionRequest start_session = 1 [json_name = "start_session"];
     */
    value: StartSessionRequest;
    case: "startSession";
  } | {
    /**
     * @generated from field: cuda_learning.StartSessionResponse start_session_response = 2 [json_name = "start_session_response"];
     */
    value: StartSessionResponse;
    case: "startSessionResponse";
  } | {
    /**
     * @generated from field: cuda_learning.SendIceCandidateRequest ice_candidate = 3 [json_name = "ice_candidate"];
     */
    value: SendIceCandidateRequest;
    case: "iceCandidate";
  } | {
    /**
     * @generated from field: cuda_learning.SendIceCandidateResponse ice_candidate_response = 4 [json_name = "ice_candidate_response"];
     */
    value: SendIceCandidateResponse;
    case: "iceCandidateResponse";
  } | {
    /**
     * @generated from field: cuda_learning.CloseSessionRequest close_session = 5 [json_name = "close_session"];
     */
    value: CloseSessionRequest;
    case: "closeSession";
  } | {
    /**
     * @generated from field: cuda_learning.CloseSessionResponse close_session_response = 6 [json_name = "close_session_response"];
     */
    value: CloseSessionResponse;
    case: "closeSessionResponse";
  } | {
    /**
     * @generated from field: cuda_learning.KeepAlive keep_alive = 7 [json_name = "keep_alive"];
     */
    value: KeepAlive;
    case: "keepAlive";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SignalingMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cuda_learning.SignalingMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_session", jsonName: "start_session", kind: "message", T: StartSessionRequest, oneof: "message" },
    { no: 2, name: "start_session_response", jsonName: "start_session_response", kind: "message", T: StartSessionResponse, oneof: "message" },
    { no: 3, name: "ice_candidate", jsonName: "ice_candidate", kind: "message", T: SendIceCandidateRequest, oneof: "message" },
    { no: 4, name: "ice_candidate_response", jsonName: "ice_candidate_response", kind: "message", T: SendIceCandidateResponse, oneof: "message" },
    { no: 5, name: "close_session", jsonName: "close_session", kind: "message", T: CloseSessionRequest, oneof: "message" },
    { no: 6, name: "close_session_response", jsonName: "close_session_response", kind: "message", T: CloseSessionResponse, oneof: "message" },
    { no: 7, name: "keep_alive", jsonName: "keep_alive", kind: "message", T: KeepAlive, oneof: "message" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignalingMessage {
    return new SignalingMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignalingMessage {
    return new SignalingMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignalingMessage {
    return new SignalingMessage().fromJsonString(jsonString, options);
  }

  static equals(a: SignalingMessage | PlainMessage<SignalingMessage> | undefined, b: SignalingMessage | PlainMessage<SignalingMessage> | undefined): boolean {
    return proto3.util.equals(SignalingMessage, a, b);
  }
}

